<template>
  <div>
    <template v-if="!printMode">
    <a-card :bordered="false" title="资产报表">
      <a-tabs v-model="activeTab" @change="onTabChange">
        <!-- 1. 折旧明细表 -->
        <a-tab-pane tab="折旧明细表" key="dep">
          <a-form layout="inline" style="margin-bottom: 12px;">
            <a-form-item label="期间起">
              <a-month-picker v-model="depQuery.begin" format="YYYY-MM" />
            </a-form-item>
            <a-form-item label="期间止">
              <a-month-picker v-model="depQuery.end" format="YYYY-MM" />
            </a-form-item>
            <a-form-item label="资产类别">
              <a-select placeholder="全部" allow-clear style="width: 140px" v-model="depQuery.categoryId">
                <a-select-option v-for="c in categoryOptions" :key="c.id" :value="c.id">{{ c.name }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="部门">
              <a-tree-select v-model="depQuery.departmentId" style="width: 150px" allow-clear treeDefaultExpandAll
                :dropdownStyle="{ maxHeight: '240px', overflow: 'auto' }" :treeData="orgTree" placeholder="全部" />
            </a-form-item>
            <a-form-item label="资产编码"><a-input v-model="depQuery.assetCode" style="width: 130px" allow-clear /></a-form-item>
            <a-form-item>
              <a-button type="primary" icon="search" @click="loadDep">查询</a-button>
              <a-button style="margin-left: 8px" icon="download" @click="exportDep">导出</a-button>
              <a-button style="margin-left: 8px" icon="printer" @click="handlePrintReport('ASSET_DEP_DETAIL', '折旧明细表', buildDepPrintData, { rows: depRows, summary: depSummary })">打印</a-button>
            </a-form-item>
          </a-form>
          <a-table bordered size="middle" rowKey="id" :columns="depColumns" :dataSource="depRows" :loading="depLoading"
            :pagination="depPage" :scroll="tableScroll" @change="(p) => onPage(p, depPage, loadDep)">
            <template slot="footer">
              合计本期折旧：{{ depSummary.depreciationAmount == null ? '***' : depSummary.depreciationAmount }}
            </template>
          </a-table>
        </a-tab-pane>

        <!-- 2. 资产台账 -->
        <a-tab-pane tab="资产台账" key="ledger">
          <a-form layout="inline" style="margin-bottom: 12px;">
            <a-form-item label="资产类别">
              <a-select placeholder="全部" allow-clear style="width: 140px" v-model="ledgerQuery.categoryId">
                <a-select-option v-for="c in categoryOptions" :key="c.id" :value="c.id">{{ c.name }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="部门">
              <a-tree-select v-model="ledgerQuery.departmentId" style="width: 150px" allow-clear treeDefaultExpandAll
                :dropdownStyle="{ maxHeight: '240px', overflow: 'auto' }" :treeData="orgTree" placeholder="全部" />
            </a-form-item>
            <a-form-item label="状态">
              <a-select placeholder="全部" allow-clear style="width: 100px" v-model="ledgerQuery.status">
                <a-select-option value="在用">在用</a-select-option>
                <a-select-option value="闲置">闲置</a-select-option>
                <a-select-option value="已处置">已处置</a-select-option>
                <a-select-option value="已报废">已报废</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="期间起"><a-month-picker v-model="ledgerQuery.begin" format="YYYY-MM" /></a-form-item>
            <a-form-item label="期间止"><a-month-picker v-model="ledgerQuery.end" format="YYYY-MM" /></a-form-item>
            <a-form-item>
              <a-button type="primary" icon="search" @click="loadLedger">查询</a-button>
              <a-button style="margin-left: 8px" icon="download" @click="exportLedger">导出</a-button>
              <a-button style="margin-left: 8px" icon="printer" @click="handlePrintReport('ASSET_LEDGER', '资产台账', buildLedgerPrintData, { rows: ledgerRows, summary: ledgerSummary })">打印</a-button>
            </a-form-item>
          </a-form>
          <a-table bordered size="middle" rowKey="id" :columns="ledgerColumns" :dataSource="ledgerRows" :loading="ledgerLoading"
            :pagination="ledgerPage" :scroll="tableScroll" @change="(p) => onPage(p, ledgerPage, loadLedger)">
            <template slot="footer">
              合计原值：{{ ledgerSummary.originalValue == null ? '***' : ledgerSummary.originalValue }}
            </template>
          </a-table>
        </a-tab-pane>

        <!-- 3. 变动汇总表 -->
        <a-tab-pane tab="变动汇总表" key="change">
          <a-form layout="inline" style="margin-bottom: 12px;">
            <a-form-item label="单据日期"><a-range-picker format="YYYY-MM-DD" v-model="changeQuery.dateRange" @change="onChangeDateRange" /></a-form-item>
            <a-form-item label="变动类型">
              <a-select placeholder="全部" allow-clear style="width: 120px" v-model="changeQuery.changeType">
                <a-select-option v-for="t in changeTypes" :key="t" :value="t">{{ t }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item>
              <a-button type="primary" icon="search" @click="loadChange">查询</a-button>
              <a-button style="margin-left: 8px" icon="download" @click="exportChange">导出</a-button>
              <a-button style="margin-left: 8px" icon="printer" @click="handlePrintReport('ASSET_CHANGE_SUMMARY', '变动汇总表', buildChangePrintData, { rows: changeRows })">打印</a-button>
            </a-form-item>
          </a-form>
          <a-table bordered size="middle" rowKey="id" :columns="changeColumns" :dataSource="changeRows" :loading="changeLoading"
            :pagination="changePage" :scroll="tableScroll" @change="(p) => onPage(p, changePage, loadChange)">
            <span slot="billTime" slot-scope="text">{{ text ? text.substring(0, 10) : '' }}</span>
          </a-table>
        </a-tab-pane>

        <!-- 4. 闲置资产清单 -->
        <a-tab-pane tab="闲置资产清单" key="idle">
          <a-form layout="inline" style="margin-bottom: 12px;">
            <a-form-item label="资产类别">
              <a-select placeholder="全部" allow-clear style="width: 140px" v-model="idleQuery.categoryId">
                <a-select-option v-for="c in categoryOptions" :key="c.id" :value="c.id">{{ c.name }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="部门">
              <a-tree-select v-model="idleQuery.departmentId" style="width: 150px" allow-clear treeDefaultExpandAll
                :dropdownStyle="{ maxHeight: '240px', overflow: 'auto' }" :treeData="orgTree" placeholder="全部" />
            </a-form-item>
            <a-form-item label="闲置时长≥(月)">
              <a-input-number v-model="idleQuery.idleMonths" :min="0" :precision="0" style="width: 120px" />
            </a-form-item>
            <a-form-item>
              <a-button type="primary" icon="search" @click="loadIdle">查询</a-button>
              <a-button style="margin-left: 8px" icon="download" @click="exportIdle">导出</a-button>
              <a-button style="margin-left: 8px" icon="printer" @click="handlePrintReport('ASSET_IDLE_LIST', '闲置资产清单', buildIdlePrintData, { rows: idleRows })">打印</a-button>
            </a-form-item>
          </a-form>
          <a-table bordered size="middle" rowKey="id" :columns="idleColumns" :dataSource="idleRows" :loading="idleLoading"
            :pagination="idlePage" :scroll="tableScroll" @change="(p) => onPage(p, idlePage, loadIdle)" />
        </a-tab-pane>

        <!-- 5. 业财对账表 -->
        <a-tab-pane tab="业财对账表" key="bizfin">
          <a-form layout="inline" style="margin-bottom: 12px;">
            <a-form-item label="对账期间"><a-month-picker v-model="bizfinQuery.month" format="YYYY-MM" /></a-form-item>
            <a-form-item>
              <a-button type="primary" icon="search" @click="loadBizfin">查询</a-button>
              <a-button style="margin-left: 8px" icon="download" @click="exportBizfin">导出</a-button>
              <a-button style="margin-left: 8px" icon="printer" @click="handlePrintReport('ASSET_BIZFIN_CHECK', '业财对账表', buildBizfinPrintData, { rows: bizfinRows, period: bizfinQuery.month ? bizfinQuery.month.format('YYYY-MM') : '' })">打印</a-button>
            </a-form-item>
          </a-form>
          <a-alert v-if="bizfinPendingTip" type="warning" show-icon style="margin-bottom: 12px;"
            :message="bizfinPendingTip" description="以上单据已审核但尚未生成总账凭证，可能导致对账差异，请等待凭证扫描或检查 gledger 配置" />
          <a-table bordered size="middle" rowKey="subjectCode" :columns="bizfinColumns" :dataSource="bizfinRows"
            :loading="bizfinLoading" :pagination="false" :scroll="tableScroll">
            <span slot="diff" slot-scope="text" :style="{ color: Number(text) !== 0 ? 'red' : '' }">{{ text }}</span>
          </a-table>
          <div v-if="noVoucherAssets.length" style="margin-top: 12px;">
            <a-divider orientation="left">无凭证资产（手工转固未选借贷科目）</a-divider>
            <a-table bordered size="small" rowKey="assetCode" :columns="noVoucherColumns" :dataSource="noVoucherAssets" :pagination="false" />
          </div>
        </a-tab-pane>

        <!-- 6. 税会差异调节表 -->
        <a-tab-pane tab="税会差异调节表" key="tax">
          <a-form layout="inline" style="margin-bottom: 12px;">
            <a-form-item label="期间"><a-month-picker v-model="taxQuery.month" format="YYYY-MM" /></a-form-item>
            <a-form-item>
              <a-button type="primary" icon="search" @click="loadTax">查询</a-button>
              <a-button style="margin-left: 8px" icon="download" @click="exportTax">导出</a-button>
              <a-button style="margin-left: 8px" icon="printer" @click="handlePrintReport('ASSET_TAX_ADJUST', '税会差异调节表', buildTaxPrintData, { rows: taxRows, summary: taxSummary, period: taxQuery.month ? taxQuery.month.format('YYYY-MM') : '' })">打印</a-button>
            </a-form-item>
          </a-form>
          <a-table bordered size="middle" rowKey="id" :columns="taxColumns" :dataSource="taxRows" :loading="taxLoading"
            :pagination="taxPage" :scroll="tableScroll" @change="(p) => onPage(p, taxPage, loadTax)">
            <template slot="footer">
              本期会计折旧：{{ taxSummary.acctCurDep }} / 本期税务折旧：{{ taxSummary.taxCurDep }} / 本期差异：{{ taxSummary.curDiff }}；
              累计会计折旧：{{ taxSummary.acctCumDep }} / 累计税务折旧：{{ taxSummary.taxCumDep }} / 累计差异：{{ taxSummary.cumDiff }}
            </template>
          </a-table>
        </a-tab-pane>

        <!-- 7. 供应商往来对账 -->
        <a-tab-pane tab="供应商往来对账" key="supplier">
          <a-form layout="inline" style="margin-bottom: 12px;">
            <a-form-item label="供应商">
              <a-select placeholder="全部" allow-clear show-search option-filter-prop="children" style="width: 180px" v-model="supplierQuery.organId">
                <a-select-option v-for="s in supList" :key="s.id" :value="s.id">{{ s.supplier }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="对账日期"><a-range-picker format="YYYY-MM-DD" v-model="supplierQuery.dateRange" @change="onSupplierDateRange" /></a-form-item>
            <a-form-item>
              <a-button type="primary" icon="search" @click="loadSupplier">查询</a-button>
              <a-button style="margin-left: 8px" icon="download" @click="exportSupplier">导出</a-button>
              <a-button style="margin-left: 8px" icon="printer" @click="handlePrintReport('ASSET_SUPPLIER_STATEMENT', '供应商往来对账', buildSupplierPrintData, { rows: supplierRows, summary: supplierSummary })">打印</a-button>
            </a-form-item>
          </a-form>
          <a-table bordered size="middle" rowKey="supplierId" :columns="supplierColumns" :dataSource="supplierRows"
            :loading="supplierLoading" :pagination="supplierPage" :scroll="tableScroll"
            @change="(p) => onPage(p, supplierPage, loadSupplier)">
            <template slot="footer">
              合计期末欠款：{{ supplierSummary.endNeed == null ? '***' : supplierSummary.endNeed }}
            </template>
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </a-card>
    </template>
    <!-- 打印模式（内嵌） -->
    <template v-if="printMode">
      <div style="display:flex; justify-content:space-between; align-items:center; padding:8px 16px; background:#fff; border-bottom:1px solid #e8e8e8; margin-bottom:12px;">
        <span style="font-size:16px; font-weight:500;">{{ printTitle }}</span>
        <a-button icon="close" @click="printMode = false">关闭</a-button>
      </div>
      <ReportPrint :visible="true" :tableData="printTableData" :queryParam="{}"
        :billType="printBillType" :billTypeName="printBillTypeName"
        :buildData="printBuildData" :embedded="true" @designer-change="onDesignerChange" />
    </template>
  </div>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { reportDepDetail, reportLedger, reportChangeSummary, reportIdleList, reportBizfinCheck,
  reportTaxAdjust, reportSupplierStatement, categoryList } from './api/fixedAsset'
import { queryOrganizationTreeList, findBySelectSup } from '@/api/api'
import ReportPrint from '@/views/plugin/print-template/ReportPrint.vue'
import { buildDepPrintData, buildLedgerPrintData, buildChangePrintData, buildIdlePrintData,
  buildBizfinPrintData, buildTaxPrintData, buildSupplierPrintData } from './assetReportConfig'

const pageNums = { current: 1, pageSize: 10, total: 0, showSizeChanger: true, pageSizeOptions: ['10', '20', '50'], showQuickJumper: true }

export default {
  name: 'AssetReportList',
  mixins: [JeecgListMixin],
  components: { ReportPrint },
  data() {
    return {
      // 打印模式（内嵌 ReportPrint）
      printMode: false,
      printTitle: '',
      printBillType: '',
      printBillTypeName: '',
      printBuildData: null,
      printTableData: {},
      activeTab: 'dep',
      categoryOptions: [],
      orgTree: [],
      supList: [],
      changeTypes: ['原值调增', '原值调减', '计提减值', '折旧政策变更', '部门转移', '状态变更'],
      tableScroll: { x: 'max-content', y: 400 },
      // 1 折旧明细
      depQuery: {}, depRows: [], depLoading: false, depPage: { ...pageNums }, depSummary: {},
      // 2 台账
      ledgerQuery: {}, ledgerRows: [], ledgerLoading: false, ledgerPage: { ...pageNums }, ledgerSummary: {},
      // 3 变动汇总
      changeQuery: {}, changeRows: [], changeLoading: false, changePage: { ...pageNums },
      // 4 闲置清单
      idleQuery: {}, idleRows: [], idleLoading: false, idlePage: { ...pageNums },
      // 5 业财对账
      bizfinQuery: {}, bizfinRows: [], bizfinLoading: false, bizfinPendingTip: '', noVoucherAssets: [],
      // 6 税会差异
      taxQuery: {}, taxRows: [], taxLoading: false, taxPage: { ...pageNums }, taxSummary: {},
      // 7 供应商对账
      supplierQuery: {}, supplierRows: [], supplierLoading: false, supplierPage: { ...pageNums }, supplierSummary: {},
      depColumns: [
        { title: '期间', dataIndex: 'period', width: 90 },
        { title: '资产编码', dataIndex: 'assetCode', width: 120 },
        { title: '资产名称', dataIndex: 'assetName', width: 160 },
        { title: '类别', dataIndex: 'categoryName', width: 120 },
        { title: '部门', dataIndex: 'departmentName', width: 110 },
        { title: '折旧方法', dataIndex: 'method', width: 100, customRender: (t) => this.methodText(t) },
        { title: '本期折旧额', dataIndex: 'depreciationAmount', width: 110 },
        { title: '累计折旧', dataIndex: 'accumulatedDepreciation', width: 110 },
        { title: '期末净值', dataIndex: 'netValue', width: 110 }
      ],
      ledgerColumns: [
        { title: '资产编码', dataIndex: 'assetCode', width: 120 },
        { title: '资产名称', dataIndex: 'assetName', width: 160 },
        { title: '规格型号', dataIndex: 'assetModel', width: 120 },
        { title: '类别', dataIndex: 'categoryName', width: 120 },
        { title: '部门', dataIndex: 'departmentName', width: 110 },
        { title: '原值', dataIndex: 'originalValue', width: 110 },
        { title: '期初累计折旧', dataIndex: 'initialAccumDep', width: 120 },
        { title: '本期计提', dataIndex: 'periodDepreciation', width: 100 },
        { title: '累计折旧', dataIndex: 'accumulatedDepreciation', width: 110 },
        { title: '减值准备', dataIndex: 'impairmentAmount', width: 100 },
        { title: '期末净值', dataIndex: 'netValue', width: 110 },
        { title: '状态', dataIndex: 'status', width: 80 }
      ],
      changeColumns: [
        { title: '单据号', dataIndex: 'billNo', width: 150 },
        { title: '单据日期', dataIndex: 'billTime', width: 110, scopedSlots: { customRender: 'billTime' } },
        { title: '资产编码', dataIndex: 'assetCode', width: 120 },
        { title: '资产名称', dataIndex: 'assetName', width: 160 },
        { title: '变动类型', dataIndex: 'changeType', width: 110 },
        { title: '变动前值', dataIndex: 'beforeValue', width: 120 },
        { title: '变动后值', dataIndex: 'afterValue', width: 120 },
        { title: '涉及金额', dataIndex: 'changeAmount', width: 110 },
        { title: '操作人', dataIndex: 'operator', width: 100 }
      ],
      idleColumns: [
        { title: '资产编码', dataIndex: 'assetCode', width: 120 },
        { title: '资产名称', dataIndex: 'assetName', width: 160 },
        { title: '类别', dataIndex: 'categoryName', width: 120 },
        { title: '部门', dataIndex: 'departmentName', width: 110 },
        { title: '原值', dataIndex: 'originalValue', width: 110 },
        { title: '累计折旧', dataIndex: 'accumulatedDepreciation', width: 110 },
        { title: '净值', dataIndex: 'netValue', width: 110 },
        { title: '闲置月数', dataIndex: 'idleMonths', width: 100 },
        { title: '最近状态变更', dataIndex: 'lastStatusChangeDate', width: 120, customRender: (t) => (t || '').substring(0, 10) }
      ],
      bizfinColumns: [
        { title: '科目编码', dataIndex: 'subjectCode', width: 100 },
        { title: '科目名称', dataIndex: 'subjectName', width: 120 },
        { title: '资产模块余额', dataIndex: 'assetValue', width: 140 },
        { title: '总账余额', dataIndex: 'glValue', width: 140 },
        { title: '差异', dataIndex: 'diff', width: 140, scopedSlots: { customRender: 'diff' } }
      ],
      noVoucherColumns: [
        { title: '转固单号', dataIndex: 'billNo', width: 150 },
        { title: '资产编码', dataIndex: 'assetCode', width: 120 },
        { title: '资产名称', dataIndex: 'assetName', width: 160 },
        { title: '原值', dataIndex: 'originalValue', width: 110 }
      ],
      taxColumns: [
        { title: '资产编码', dataIndex: 'assetCode', width: 120 },
        { title: '资产名称', dataIndex: 'assetName', width: 160 },
        { title: '原值', dataIndex: 'originalValue', width: 110 },
        { title: '本期会计折旧', dataIndex: 'acctCurDep', width: 120 },
        { title: '本期税务折旧', dataIndex: 'taxCurDep', width: 120 },
        { title: '本期差异', dataIndex: 'curDiff', width: 110 },
        { title: '累计会计折旧', dataIndex: 'acctCumDep', width: 120 },
        { title: '累计税务折旧', dataIndex: 'taxCumDep', width: 120 },
        { title: '累计差异', dataIndex: 'cumDiff', width: 110 }
      ],
      supplierColumns: [
        { title: '供应商', dataIndex: 'supplier', width: 160 },
        { title: '联系人', dataIndex: 'contacts', width: 100 },
        { title: '电话', dataIndex: 'telephone', width: 130 },
        { title: '期初欠款', dataIndex: 'beginNeed', width: 110 },
        { title: '本期商品欠款', dataIndex: 'goodsDebt', width: 130 },
        { title: '本期资产转固欠款', dataIndex: 'assetDebt', width: 150 },
        { title: '本期资产核销', dataIndex: 'assetPay', width: 120 },
        { title: '本期商品付款', dataIndex: 'pay', width: 120 },
        { title: '期末欠款', dataIndex: 'endNeed', width: 110 }
      ]
    }
  },
  computed: {
    bizfinPendingTip() {
      const p = this.bizfinPendingCounts
      if (!p) return ''
      const parts = []
      if (p.transfer) parts.push('转固单 ' + p.transfer + ' 张')
      if (p.change) parts.push('变动单 ' + p.change + ' 张')
      if (p.repair) parts.push('维修单 ' + p.repair + ' 张')
      if (p.dep) parts.push('折旧计提单 ' + p.dep + ' 张')
      if (p.disposal) parts.push('处置单 ' + p.disposal + ' 张')
      return parts.length ? '在途未扫描凭证：' + parts.join('，') : ''
    }
  },
  mounted() {
    this.$nextTick(() => { this.tableScroll.y = Math.max(300, window.innerHeight - 400) })
  },
  created() {
    this.bizfinPendingCounts = null
    categoryList().then((res) => { if (res && res.success) this.categoryOptions = res.data || [] })
    queryOrganizationTreeList({}).then((res) => {
      if (res && res.code === 200) this.orgTree = this.buildTree(res.data || [])
    })
    findBySelectSup({}).then((res) => { if (res) this.supList = res })
    this.loadDep()
  },
  methods: {
    // ==================== 报表打印 ====================
    // 暴露给模板使用（Vue2 模板只能访问实例属性，参照 SalesRankingList 的 buildPrintData 暴露方式）
    buildDepPrintData,
    buildLedgerPrintData,
    buildChangePrintData,
    buildIdlePrintData,
    buildBizfinPrintData,
    buildTaxPrintData,
    buildSupplierPrintData,
    handlePrintReport(billType, billTypeName, buildFn, data) {
      if (!data || !data.rows || data.rows.length === 0) {
        this.$message.warning('暂无数据可打印')
        return
      }
      this.printBillType = billType
      this.printBillTypeName = billTypeName
      this.printBuildData = buildFn
      this.printTableData = data
      this.printTitle = billTypeName + '-打印预览'
      this.printMode = true
    },
    onDesignerChange(visible) {
      this.printTitle = this.printBillTypeName + (visible ? '-报表设计' : '-打印预览')
    },
    methodText(m) {
      const map = { 1: '年限平均法', 2: '工作量法', 3: '双倍余额递减', 4: '年数总和法' }
      return map[m] || m || ''
    },
    buildTree(list) {
      return list.map((n) => ({ key: n.id, value: n.id, title: n.title || n.orgAbr || n.name, children: n.children ? this.buildTree(n.children) : [] }))
    },
    onPage(pag, pageObj, loader) {
      pageObj.current = pag.current
      pageObj.pageSize = pag.pageSize
      loader()
    },
    splitYm(v) {
      // a-month-picker 的 moment 值 → {year, month}
      if (!v) return {}
      const s = (typeof v === 'string' ? v : v.format('YYYY-MM'))
      const arr = s.split('-')
      return { year: Number(arr[0]), month: Number(arr[1]) }
    },
    onChangeDateRange(dateString) {
      if (dateString && dateString.length === 2) {
        this.changeQuery.beginTime = dateString[0]
        this.changeQuery.endTime = dateString[1]
      } else {
        this.changeQuery.beginTime = ''
        this.changeQuery.endTime = ''
      }
    },
    onSupplierDateRange(dateString) {
      if (dateString && dateString.length === 2) {
        this.supplierQuery.beginTime = dateString[0]
        this.supplierQuery.endTime = dateString[1]
      } else {
        this.supplierQuery.beginTime = ''
        this.supplierQuery.endTime = ''
      }
    },
    onTabChange(key) {
      if (key === 'dep' && !this.depRows.length) this.loadDep()
      if (key === 'ledger' && !this.ledgerRows.length) this.loadLedger()
      if (key === 'change' && !this.changeRows.length) this.loadChange()
      if (key === 'idle' && !this.idleRows.length) this.loadIdle()
      if (key === 'bizfin' && !this.bizfinRows.length) this.loadBizfin()
      if (key === 'tax' && !this.taxRows.length) this.loadTax()
      if (key === 'supplier' && !this.supplierRows.length) this.loadSupplier()
    },
    // ==================== 1 折旧明细 ====================
    loadDep() {
      this.depLoading = true
      const b = this.splitYm(this.depQuery.begin)
      const e = this.splitYm(this.depQuery.end)
      reportDepDetail({
        beginYear: b.year || null, beginMonth: b.month || null, endYear: e.year || null, endMonth: e.month || null,
        categoryId: this.depQuery.categoryId || null, departmentId: this.depQuery.departmentId || null,
        assetCode: this.depQuery.assetCode || null,
        page: this.depPage.current, pageSize: this.depPage.pageSize
      }).then((res) => {
        this.depLoading = false
        if (res && res.success) {
          this.depRows = res.data.records || []
          this.depPage.total = res.data.total || 0
          this.depSummary = res.data.summary || {}
        } else { this.$message.error((res && res.message) || '查询失败') }
      }).catch(() => { this.depLoading = false })
    },
    exportDep() {
      const list = this.depRows.map((r) => [r.period || '', r.assetCode || '', r.assetName || '', r.categoryName || '',
        r.departmentName || '', this.methodText(r.method), r.depreciationAmount == null ? '' : r.depreciationAmount,
        r.accumulatedDepreciation == null ? '' : r.accumulatedDepreciation, r.netValue == null ? '' : r.netValue])
      this.handleExportXlsPost('折旧明细表', '折旧明细表', '期间,资产编码,资产名称,类别,部门,折旧方法,本期折旧额,累计折旧,期末净值', '', list)
    },
    // ==================== 2 台账 ====================
    loadLedger() {
      this.ledgerLoading = true
      const b = this.splitYm(this.ledgerQuery.begin)
      const e = this.splitYm(this.ledgerQuery.end)
      reportLedger({
        categoryId: this.ledgerQuery.categoryId || null, departmentId: this.ledgerQuery.departmentId || null,
        status: this.ledgerQuery.status || null,
        beginYear: b.year || null, beginMonth: b.month || null, endYear: e.year || null, endMonth: e.month || null,
        page: this.ledgerPage.current, pageSize: this.ledgerPage.pageSize
      }).then((res) => {
        this.ledgerLoading = false
        if (res && res.success) {
          this.ledgerRows = res.data.records || []
          this.ledgerPage.total = res.data.total || 0
          this.ledgerSummary = res.data.summary || {}
        } else { this.$message.error((res && res.message) || '查询失败') }
      }).catch(() => { this.ledgerLoading = false })
    },
    exportLedger() {
      const list = this.ledgerRows.map((r) => [r.assetCode || '', r.assetName || '', r.assetModel || '', r.categoryName || '',
        r.departmentName || '', r.originalValue == null ? '' : r.originalValue, r.initialAccumDep == null ? '' : r.initialAccumDep,
        r.periodDepreciation == null ? '' : r.periodDepreciation, r.accumulatedDepreciation == null ? '' : r.accumulatedDepreciation,
        r.impairmentAmount == null ? '' : r.impairmentAmount, r.netValue == null ? '' : r.netValue, r.status || ''])
      this.handleExportXlsPost('资产台账', '资产台账', '资产编码,资产名称,规格型号,类别,部门,原值,期初累计折旧,本期计提,累计折旧,减值准备,期末净值,状态', '', list)
    },
    // ==================== 3 变动汇总 ====================
    loadChange() {
      this.changeLoading = true
      reportChangeSummary({
        beginTime: this.changeQuery.beginTime || null, endTime: this.changeQuery.endTime || null,
        changeType: this.changeQuery.changeType || null,
        page: this.changePage.current, pageSize: this.changePage.pageSize
      }).then((res) => {
        this.changeLoading = false
        if (res && res.success) {
          this.changeRows = res.data.records || []
          this.changePage.total = res.data.total || 0
        } else { this.$message.error((res && res.message) || '查询失败') }
      }).catch(() => { this.changeLoading = false })
    },
    exportChange() {
      const list = this.changeRows.map((r) => [r.billNo || '', (r.billTime || '').substring(0, 10), r.assetCode || '',
        r.assetName || '', r.changeType || '', r.beforeValue || '', r.afterValue || '',
        r.changeAmount == null ? '' : r.changeAmount, r.operator || ''])
      this.handleExportXlsPost('资产变动汇总表', '资产变动汇总表', '单据号,单据日期,资产编码,资产名称,变动类型,变动前值,变动后值,涉及金额,操作人', '', list)
    },
    // ==================== 4 闲置清单 ====================
    loadIdle() {
      this.idleLoading = true
      reportIdleList({
        categoryId: this.idleQuery.categoryId || null, departmentId: this.idleQuery.departmentId || null,
        idleMonths: this.idleQuery.idleMonths || null,
        page: this.idlePage.current, pageSize: this.idlePage.pageSize
      }).then((res) => {
        this.idleLoading = false
        if (res && res.success) {
          this.idleRows = res.data.records || []
          this.idlePage.total = res.data.total || 0
        } else { this.$message.error((res && res.message) || '查询失败') }
      }).catch(() => { this.idleLoading = false })
    },
    exportIdle() {
      const list = this.idleRows.map((r) => [r.assetCode || '', r.assetName || '', r.categoryName || '', r.departmentName || '',
        r.originalValue == null ? '' : r.originalValue, r.accumulatedDepreciation == null ? '' : r.accumulatedDepreciation,
        r.netValue == null ? '' : r.netValue, r.idleMonths == null ? '' : r.idleMonths,
        (r.lastStatusChangeDate || '').substring(0, 10)])
      this.handleExportXlsPost('闲置资产清单', '闲置资产清单', '资产编码,资产名称,类别,部门,原值,累计折旧,净值,闲置月数,最近状态变更', '', list)
    },
    // ==================== 5 业财对账 ====================
    loadBizfin() {
      const ym = this.splitYm(this.bizfinQuery.month)
      if (!ym.year) { this.$message.warning('请选择对账期间'); return }
      this.bizfinLoading = true
      reportBizfinCheck({ year: ym.year, month: ym.month }).then((res) => {
        this.bizfinLoading = false
        if (res && res.success) {
          this.bizfinRows = res.data.rows || []
          this.bizfinPendingCounts = res.data.pending || null
          this.noVoucherAssets = res.data.noVoucherAssets || []
        } else { this.$message.error((res && res.message) || '查询失败') }
      }).catch(() => { this.bizfinLoading = false })
    },
    exportBizfin() {
      const list = this.bizfinRows.map((r) => [r.subjectCode || '', r.subjectName || '',
        r.assetValue == null ? '' : r.assetValue, r.glValue == null ? '' : r.glValue, r.diff == null ? '' : r.diff])
      this.handleExportXlsPost('业财对账表', '业财对账表', '科目编码,科目名称,资产模块余额,总账余额,差异', '', list)
    },
    // ==================== 6 税会差异 ====================
    loadTax() {
      const ym = this.splitYm(this.taxQuery.month)
      if (!ym.year) { this.$message.warning('请选择期间'); return }
      this.taxLoading = true
      reportTaxAdjust({ year: ym.year, month: ym.month, page: this.taxPage.current, pageSize: this.taxPage.pageSize }).then((res) => {
        this.taxLoading = false
        if (res && res.success) {
          this.taxRows = res.data.records || []
          this.taxPage.total = res.data.total || 0
          this.taxSummary = res.data.summary || {}
        } else { this.$message.error((res && res.message) || '查询失败') }
      }).catch(() => { this.taxLoading = false })
    },
    exportTax() {
      const list = this.taxRows.map((r) => [r.assetCode || '', r.assetName || '', r.originalValue == null ? '' : r.originalValue,
        r.acctCurDep == null ? '' : r.acctCurDep, r.taxCurDep == null ? '' : r.taxCurDep, r.curDiff == null ? '' : r.curDiff,
        r.acctCumDep == null ? '' : r.acctCumDep, r.taxCumDep == null ? '' : r.taxCumDep, r.cumDiff == null ? '' : r.cumDiff])
      this.handleExportXlsPost('税会差异调节表', '税会差异调节表', '资产编码,资产名称,原值,本期会计折旧,本期税务折旧,本期差异,累计会计折旧,累计税务折旧,累计差异', '', list)
    },
    // ==================== 7 供应商对账 ====================
    loadSupplier() {
      this.supplierLoading = true
      reportSupplierStatement({
        organId: this.supplierQuery.organId || null,
        beginTime: this.supplierQuery.beginTime || null, endTime: this.supplierQuery.endTime || null,
        page: this.supplierPage.current, pageSize: this.supplierPage.pageSize
      }).then((res) => {
        this.supplierLoading = false
        if (res && res.success) {
          this.supplierRows = res.data.records || []
          this.supplierPage.total = res.data.total || 0
          this.supplierSummary = res.data.summary || {}
        } else { this.$message.error((res && res.message) || '查询失败') }
      }).catch(() => { this.supplierLoading = false })
    },
    exportSupplier() {
      const list = this.supplierRows.map((r) => [r.supplier || '', r.contacts || '', r.telephone || '',
        r.beginNeed == null ? '' : r.beginNeed, r.goodsDebt == null ? '' : r.goodsDebt, r.assetDebt == null ? '' : r.assetDebt,
        r.assetPay == null ? '' : r.assetPay, r.pay == null ? '' : r.pay, r.endNeed == null ? '' : r.endNeed])
      this.handleExportXlsPost('供应商往来对账', '供应商往来对账', '供应商,联系人,电话,期初欠款,本期商品欠款,本期资产转固欠款,本期资产核销,本期商品付款,期末欠款', '', list)
    }
  }
}
</script>
